import { render, staticRenderFns } from "./topDataCard.vue?vue&type=template&id=38cf5a9b&"
import script from "./topDataCard.vue?vue&type=script&lang=js&"
export * from "./topDataCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports